import { DateObject } from '../reusables/date-object';
import { Currency } from '../reusables/currency';

/**
 * Blueprint for the magento orders.
 */
export class Order {
  public id: number;
  public currency: string;
  public orderItems: Array<OrderItem> = [];
  public invoiceNumber: string;
  public priceTotal: number;
  public purchaseDateTime: DateObject;
  public quantity: number;

  constructor(order?: any) {
    this.id = order.id;
    this.currency = order.currency;

    for (const orderItem of order.orderItems) {
      this.orderItems.push(new OrderItem(orderItem));
    }

    this.invoiceNumber = order.orderGroupId;
    this.priceTotal = order.priceTotal;
    this.purchaseDateTime = new DateObject(order.dateTime, 'dd.MM.yyyy HH:mm');

    this.quantity = order.quantity;
  }

  get fullPrice(): Currency {
    return new Currency(this.priceTotal, this.currency);
  }
}

/**
 * Blueprint for the order item.
 */
 export class OrderItem {
  public id: number;
  public itemId: number;
  public quantity: number;
  public name: string;
  public price: number;

  constructor(orderItem?: any) {
    this.id = orderItem.id;
    this.itemId = orderItem.itemId;
    this.quantity = orderItem.quantity;
    this.name = orderItem.name;
    this.price = orderItem.price;
  }
}
